import React, { Component } from "react";
import { Container, Row } from "reactstrap";
//Import Section Title
import SectionTitle from "../common/section-title";
import ServiceBox from "./services-box";

class Process extends Component {
  constructor(props) {
    super(props);
    this.state = {
      services: [
        {
          icon: "clipboard",
          title: "Official Donation Receipts",
          desc: "We provide a legel donation recipient for your donations",
        },
        {
          icon: "credit-card",
          title: "Different Payment Methods",
          desc:
            "We provide a different set of payment options including in app payment",
        },
        {
          icon: "dollar-sign",
          title: "Foreign Payment Support",
          desc:
            "Want to donate to our campaigns with foreign currencies? Don't worry we support international payment gateways: anyone abroad can support you on your cause.",
        },
      ],
    };
  }

  render() {
    return (
      <React.Fragment>
        <section className="section bg-light" id="services">
          <Container>
            <SectionTitle
              subtitle="Qualities"
              title="Quality in Us"
              desc="We provide our customers a platform for their purpose of fundraising in accountable, transparent and fraud free manner."
            />

            <Row>
              <ServiceBox services={this.state.services} />
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Process;
